<div class="container-fluid padMob bg webView" style="padding-left: 5px; padding-right: 0px;">
    <div class="row" style="margin: 0px;">
        <!-- Header-->
        <div class="col-md-12 col-12 col-sm-12 padZero bgWhite padHeder" style="padding-bottom: 0px;">
            <div class="col-md-6 col-sm-12 col-12 inLneBlk padZero" style="display: inline-block;">
                <span class="lblHeader newHeader" style="font-weight: 500; font-size: 32px;">Accounts Reports</span>&nbsp;&nbsp;
                <!-- <span style="font-size: 17px;">
                    Coming Soon
                </span> -->
            </div>

            <div class="col-md-6 col-sm-12 col-12 inLneBlk padZero" style="display: inline-block;text-align: right;">
                <div class="com-md-3 col-lg-3" style="display: inline-block; text-align: right; padding: 0px;"
                    title="Back to Account Dashboard">
                    <span class="darkBlueButton" style="font-size: 13px; display: inline-block; padding: 5px 12px 6px;"
                        (click)="backBtn()">
                        <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Back
                    </span>
                </div>
            </div>
        </div>

        <!-- Body-->
        <div class="col-md-12 col-12 col-sm-12 bgWhite">
            <div class="col-md-12 padZero" style="margin-top: 10px; margin-bottom: 5px;" *ngFor="let i of reportArr"
                [hidden]="(i.isAcctsCfg && !right?.AcctsCfg) || (i.title == 'Export' && !isETally)">
                <div class="divHeaderForCard padZero">
                    <span class="{{i.titleColorCls}}">{{i.title}}</span>
                </div>

                <div class="row padZero" style="margin: 0px;">
                    <div class="col-md-3 alignClass" style="padding-left: 0px;cursor: {{r.cursor}};" *ngFor="let r of i.reportItems">
                        <div class="dashBox dashBox-stats {{r.class}}" style="margin-top: 10px;"
                            (click)="AccountReportsRedirect(r.index)">
                            <div class="dashBox-coloured-header {{i.itemHeaderColorCls}}">
                                <h3 class="dashBox-title" style="font-size: 17px;">{{r.title}}</h3>
                            </div>
                            <div>
                                <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                    style="line-height: 22px;">{{r.desc}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>